import script from "./Sign.vue?vue&type=script&setup=true&lang=js"
export * from "./Sign.vue?vue&type=script&setup=true&lang=js"

import "./Sign.vue?vue&type=style&index=0&id=1e84db2b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e84db2b"]])

export default __exports__